module.exports = __webpack_public_path__ + "static/media/User@1x.7c201100.svg";